import React from "react";
import { NavLink } from "react-router-dom";
import { BarChart3, Users, Gift, ShieldCheck, Settings } from "lucide-react";

const TABS = [
  { to: "/admin/dashboard", label: "Dashboard", Icon: BarChart3, testId: "admin-bnav-dashboard" },
  { to: "/admin/customers", label: "Customers", Icon: Users, testId: "admin-bnav-customers" },
  { to: "/admin/rewards", label: "Rewards", Icon: Gift, testId: "admin-bnav-rewards" },
  { to: "/admin/staff", label: "Staff", Icon: ShieldCheck, testId: "admin-bnav-staff" },
  { to: "/admin/settings", label: "Settings", Icon: Settings, testId: "admin-bnav-settings" },
];

const TabButton = ({ to, label, Icon, testId }) => (
  <NavLink
    to={to}
    data-testid={testId}
    className={({ isActive }) =>
      [
        "relative flex flex-1 flex-col items-center justify-center h-full",
        "font-body font-semibold text-[9px] tracking-[0.1em] uppercase",
        "transition-colors duration-200",
        isActive ? "text-napoli-gold" : "text-napoli-cream/60 hover:text-napoli-cream/85",
      ].join(" ")
    }
  >
    {({ isActive }) => (
      <>
        {isActive ? <span aria-hidden className="absolute top-1.5 h-0.5 w-6 bg-napoli-gold" /> : null}
        <Icon
          size={20}
          strokeWidth={1.6}
          className="mb-0.5"
          style={isActive ? { filter: "drop-shadow(0 0 6px rgba(197,160,77,0.55))" } : undefined}
        />
        <span>{label}</span>
      </>
    )}
  </NavLink>
);

export const AdminBottomNav = () => (
  <nav
    data-testid="admin-bottom-nav"
    aria-label="Admin navigation"
    className="md:hidden fixed bottom-0 left-0 right-0 h-[72px] bg-napoli-espresso flex items-stretch z-30 border-t border-napoli-gold/20"
  >
    {TABS.map((t) => (
      <TabButton key={t.to} {...t} />
    ))}
  </nav>
);

export default AdminBottomNav;
